import { jsonFetch } from '@bwoty-web/utils';
import { fetch, Uri } from '../utils/fetch';
import { urlUtils } from '../utils/url';

export const fetchLabels = async (siteSettings, alias) => {
  const { siteId, baseUrl } = siteSettings;

  const url = `${baseUrl}/api/attribute-collection?siteId=${siteId}&alias=${alias}`;

  const labels = await jsonFetch(url, {
    method: 'GET',
    caller: 'independentWeb',
  });

  if (!labels) {
    return {};
  }

  return {
    ...labels,
    general: labels.iwGeneral,
    errors: labels.iwErrors,
    priceDetails: labels.iwPriceDetails,
  };
};

export const fetchDestinationContent = async (siteSettings) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const areaCaId = urlUtils.getAreaIdFromUrl();
  const resortCaId = urlUtils.getResortIdFromUrl();
  const hasAreaId = areaCaId > 0;

  const type = hasAreaId ? 'area' : 'resort';

  const uri = new Uri({
    domain: apiUrl,
    path: `/api/content/${type}`,
    query: {
      caId: hasAreaId ? areaCaId : resortCaId,
      siteId,
    },
  });

  const response = await fetch.getJsonByProxy(uri, baseUrl);
  return response;
};
